module.exports = __webpack_public_path__ + "img/banner2026-2.6c145887.webp";